export default __webpack_public_path__ + "static/fb-79dd641e1327cc5df34b44c79fb9e048.svg";